import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import { useTable } from 'react-table';
import truncate from 'lodash/truncate';
import useSelections from '@/components/widget/misc/useSelections';
import useSelectionLabels from '@/components/widget/misc/useSelectionLabels';
import Tooltip from '@/components/Tooltip';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import { hasAnySelectionData } from '../../utils/selections';
import settings, { selectionConfig, labelsSelectionConfig } from './settings';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../../misc/StyleVariables';
import Loading from './Loading';
import Header from '../misc/Header';
import useData from './useData';
import { useTableStyles } from './stylesTheme';
import useSubscribeWidgetResults from '../hooks/useSubscribeWidgetResults';
import commonStyles from '../styles/common.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const Table = _ref => {
  let {
    reportingWidgetId,
    elementId,
    config,
    sectionId,
    widgetId,
    editing = false
  } = _ref;
  const {
    globalSeriesOptions,
    seriesOptions = [],
    selectionsStrategy = '',
    selectionsLabeled = false,
    selections = '',
    labelsSelections = ''
  } = config;
  const {
    defaultStyles
  } = useTableStyles();
  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults,
    resultsUpdated
  } = useSelections({
    results,
    selections,
    selectionConfig,
    selectionsLabeled
  });
  const {
    selectionLabels
  } = useSelectionLabels({
    results,
    resultsUpdated,
    labelsSelections,
    labelsSelectionConfig,
    selectionsLabeled,
    labelsTemplate: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.labelsTemplate
  }); // Combine results with rendering styles

  const {
    data,
    columns,
    hasHeaders
  } = useData({
    selectionsStrategy,
    selectionsLabeled,
    results: selectionResults,
    selectionLabels,
    seriesOptions,
    globalSeriesOptions
  }); // Data & Loading States

  const hasNoData = !hasAnySelectionData(selectionResults);
  const isLoading = !results.length;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: styles.container
  }, getSectionAttr(widgetId, sectionId)), {}, {
    children: [/*#__PURE__*/_jsx(Header, {
      editing: editing,
      widgetId: widgetId,
      sectionId: sectionId,
      config: config
    }), isLoading || hasNoData ? /*#__PURE__*/_jsx(Loading, {
      selections: config.selections,
      widgetId: widgetId,
      sectionId: sectionId,
      selectionsLabeled: selectionsLabeled,
      selectionsStrategy: selectionsStrategy,
      seriesOptions: seriesOptions,
      editing: editing
    }) : /*#__PURE__*/_jsx("div", {
      className: styles.tableWrapper,
      children: /*#__PURE__*/_jsxs("table", _objectSpread(_objectSpread({}, getTableProps()), {}, {
        className: styles.table,
        children: [hasHeaders ? /*#__PURE__*/_jsx("thead", {
          children: headerGroups.map((headerGroup, hgIndex) => /*#__PURE__*/_createElement("tr", _objectSpread(_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
            key: `${widgetId}-${sectionId}-hg-${hgIndex}`
          }), headerGroup.headers.map((column, colIndex) => {
            const tooltip = (selectionsStrategy === 'columns' && seriesOptions[colIndex] || {}).tooltip || '';
            return /*#__PURE__*/_createElement("th", _objectSpread(_objectSpread(_objectSpread({
              className: clsx(styles.headerColumn, tooltip ? styles['headerColumn--icon'] : '')
            }, column.getHeaderProps()), {}, {
              key: `${widgetId}-${sectionId}-${hgIndex}-h-${colIndex}`
            }, editing && {
              [getEditingAreaAttr()]: `item-${column.selectionIndex}`
            }), editing && {
              [getEditingAreaMetaDataAttr()]: JSON.stringify({
                selection: getFirstSelection(column.selection),
                selectionIndex: column.selectionIndex
              })
            }), column.render('Header'), tooltip ? /*#__PURE__*/_jsx(Tooltip, {
              placement: colIndex === 0 ? 'right' : 'left',
              content: truncate(tooltip, {
                length: 65
              }),
              className: clsx(commonStyles.title__icon, styles.headerColumn__icon),
              children: /*#__PURE__*/_jsx(InfoIcon, {})
            }) : /*#__PURE__*/_jsx(_Fragment, {}));
          })))
        }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("tbody", _objectSpread(_objectSpread({}, getTableBodyProps()), {}, {
          children: rows.map((row, rowIndex) => {
            prepareRow(row);
            return /*#__PURE__*/_createElement("tr", _objectSpread(_objectSpread({}, row.getRowProps()), {}, {
              key: `${widgetId}-${sectionId}-row-${rowIndex}`
            }), row.cells.map((cell, cellIndex) => {
              const selection = row.original[`colSelection${cellIndex}`];
              const selectionIndex = row.original[`colSelectionIndex${cellIndex}`];
              return /*#__PURE__*/_createElement("td", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                className: styles.bodyColumn
              }, cell.getCellProps()), {}, {
                key: `${widgetId}-${sectionId}-${rowIndex}-cell-${cellIndex}`
              }, editing && {
                [getEditingAreaMetaDataAttr()]: selectionIndex
              }), editing && {
                [getEditingAreaAttr()]: `item-${selectionIndex}`
              }), editing && {
                [getEditingAreaMetaDataAttr()]: JSON.stringify({
                  selection: getFirstSelection(selection),
                  selectionIndex
                })
              }), cell.render('Cell'));
            }));
          })
        }))]
      }))
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: _objectSpread(_objectSpread(_objectSpread({}, settings.styles), config.styles || {}), defaultStyles)
    })]
  }));
};

export default Table;
export { settings, selectionConfig, labelsSelectionConfig }; // Sanity check for some merged selections

function getFirstSelection(selection) {
  return selection.split('|')[0];
}